import { createSlice } from '@reduxjs/toolkit';
import { getCreatorInfo } from '../actions';
import { Article } from '../actions/types';

export interface Creator {
    username: string;
    fullname: string;
    items: Article[];
    portrait: string;
    biography: string;
    loading?: boolean;
}

interface Creators {
    creators: Creator[];
}

const initialState: Creators = {
    creators: []
}

export const creatorSlice = createSlice({
    name: 'creator',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getCreatorInfo.pending, (state, action) => {
            if (action.meta && !state.creators.find(user => user.username === action.meta.arg)) {
                state.creators = [...state.creators, { 
                    username: action.meta.arg,
                    fullname: '',
                    biography: '',
                    items: [],
                    portrait: '',
                    loading: true
                }]
            }
        })
        .addCase(getCreatorInfo.fulfilled, (state, action) => {
            if (action.payload){
                state.creators = [...state.creators.filter(user => user.username !== action.payload.username), { ...action.payload, loading: false }]
            }
        })
    }
})

export default creatorSlice.reducer;